var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4546_62054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18075 4.83918C0.715905 4.32395 0.661837 3.61513 1.05722 3.21974L3.14845 1.12851C3.54384 0.733126 4.25267 0.787195 4.76789 1.25204L10.4765 6.40249C11.0403 6.91122 11.1513 7.7078 10.7186 8.14051L8.06922 10.7899C7.63652 11.2226 6.83993 11.1116 6.3312 10.5477L1.18075 4.83918Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64068 5.52954C4.64521 5.04512 5.0368 4.65352 5.52123 4.64899L12.1816 4.5868C12.9775 4.57936 13.3812 5.54138 12.8184 6.10418L6.09587 12.8268C5.53307 13.3896 4.57105 12.9858 4.57848 12.1899L4.64068 5.52954Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28838 9.05664L9.174 7.17102L15.0531 13.9908C15.2822 14.2565 15.2675 14.654 15.0194 14.9021C14.7713 15.1501 14.3739 15.1648 14.1082 14.9358L7.28838 9.05664Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4546_62054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.5f13c7d005f61d3c798430ae88917864.svg";
export { ForwardRef as ReactComponent };